import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { useSettingsStore } from '@core/store';

export interface MetricRow {
    label: string;
    value: number | string;
}

export interface InsightsCardProps {
    heading: string;
    rows: MetricRow[];
    onClick: () => void;
    minRows?: number;
}

const InsightsCard = ({ heading, rows, onClick, minRows }: InsightsCardProps) => {
    const { darkMode } = useSettingsStore();
    const totalRows = minRows !== undefined ? Math.max(rows.length, minRows) : rows.length;

    return (
        <div className="col" onClick={onClick} style={{ cursor: 'pointer' }}>
            <div
                className="data-table__wrapper"
                style={{ backgroundColor: darkMode ? 'var(--dark-bg)' : undefined, overflow: 'hidden' }}
            >
                <Table
                    sx={{
                        '&& .MuiTableBody-root.card-view .MuiTableRow-root:last-child .MuiTableCell-root': {
                            borderBottom: 'none !important'
                        }
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={2} sx={{ fontSize: '17px' }}>
                                {heading}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="card-view">
                        {Array.from({ length: totalRows }).map((_, index) => {
                            const row = rows[index];
                            return (
                                <TableRow key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                                    <TableCell>{row?.label ?? '\u00A0'}</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                        <span style={{ paddingRight: '50px' }}>{row?.value ?? '\u00A0'}</span>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default InsightsCard;
